import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material"
import useStyles from '../../../../../styles/global-mui.js';

const MultiSelectTags = ({match, tags, handleTagChange}) => {

  const classes = useStyles();

  if(match.type === 'match')
    return ''

    return (<Box sx={{ marginTop: 2 }}>
            <FormControl fullWidth className={classes.customInput}>
              <InputLabel id="select-multiple-tags-label">
                Tags
              </InputLabel>
              <Select
                labelId="select-multiple-tags-label"
                id="select-multiple-tags"
                multiple
                value={tags}
                onChange={handleTagChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={match.tags.find(tag => tag._id === value)?.name || value} />
                    ))}
                  </Box>
                )}
              >
                {match.tags && match.tags.map((tag) => (
                  <MenuItem key={tag._id} value={tag._id}>
                    {tag.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>)
}

export default MultiSelectTags